import * as types from '../mutation-types'
import { FATE_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: () => ({
        fromParent: 'detail',
        showTypeList: ['dayun', 'liunian', 'liuyue', 'liuri', 'liushi'],
        detailData: {},
        fateInfo: {},
        fateListData: [],
        fateSideListData: [],
        fortuneTitle: '',
        fortuneListData: [],
        fortuneSideListData: [],
        showTable: 5,
        showType: 'dayun',
        subTitle: '',
        curDaYun: {},
        liunianListData: [],
        liuyueListData: [],
        liuriListData: [],
        liushiListData: []
    }),
    getters: {},
    mutations: {
        // 排盘页:命盘+运盘:数据操作
        [types.PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA](state, data) {
            state.detailData = data;
            state.fateInfo = data.fateInfo;
            state.fateListData = data.fateListData;
            state.fortuneTitle = data.fortuneTitle;
            state.fortuneListData = data.fortuneListData;
            state.detailInfoData = data.detailInfo;

            // 处理当前大运
            var resultData = data.fortuneListData.filter(ffData => {return ffData.current});
                resultData = resultData.length > 0 ? resultData : data.fortuneListData;
            state.curDaYun = resultData[0];
            // 10列布局
            if(state.showTable == 10 && state.showType == 'dayun' && state.fromParent != 'contrast') {
                AppFate.$store.dispatch('detail/fatefortune/showDetailLiuNian', state.curDaYun);
            }

            // 检测到有修改之后,去掉命盘部分右边栏选中数据:并重置命盘+运盘
            if(AppFate.$store.state.editChangeBirthday){
                AppFate.$store.state.editChangeBirthday = false;
                state.showType = "dayun";
                state.subTitle = '';
                state.fateSideListData.splice(0);
            }
            console.log('types.PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA------', AppFate.$store.state.editChangeBirthday, data);
        },
        [types.PLUGIN_INIT_DETAIL_FATE_SIDE_ADD](state, data) {
            if(!data) { return; }
            var subTitle = state.subTitle;
            var originData = state.fateSideListData;
            var resultData = {}, maxLength = state.showTypeList.indexOf(data.type) + 1;

            // console.log('addd-------', state.showType, data.type, maxLength)
            
            // 特殊处理:在未点击大运的前提下点击当前大运的流年
            if(data.type == 'liunian' && originData.length == 0) {
                AppFate.$store.dispatch("detail/fatefortune/addDetailFateSide", state.curDaYun);
                subTitle = subTitle + (state.curDaYun.ganzhi + "大运");
            }

            // 检查当前:10列:是上一级别的话，就更新数据不操作dom
            if(data.type != 'liushi'){
                if(originData.length >= maxLength) {
                    resultData = FATE_DATA_MANAGER.updateFateSideData(subTitle, originData, data);
                }else{
                    resultData = FATE_DATA_MANAGER.addFateSideData(subTitle, originData, data);
                }
                state.subTitle = resultData.title;
                state.fateSideListData = resultData.data;
            }

            // 更新当前选中状态
            switch(data.type){
                case 'dayun':
                    state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, data);
                    break;
                case 'liunian':
                    state.liunianListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liunianListData, data);
                    break;
                case 'liuyue':
                    state.liuyueListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liuyueListData, data);
                    break;
                case 'liuri':
                    state.liuriListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liuriListData, data);
                    break;
                case 'liushi':
                    state.liushiListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liushiListData, data);
                    break;
                default:
                    break;
            }
            
            // 更新合化冲数据状态
            AppFate.$store.state.detail.updateRelation = true;
    
            console.log("types.DETAIL_FATE_SIDE_ADD", state.subTitle, state.fateSideListData, data)
        },
        [types.PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE](state, data) {
            var subTitle = state.subTitle;
            var originData = state.fateSideListData;
            // console.log('deeeeeeeeeeeeeeeelete------', data.type, state.fortuneListData, state.liunianListData)

            var resultData = FATE_DATA_MANAGER.deleteFateSideData(subTitle, originData, data);
            state.showType = resultData.type;
            state.subTitle = resultData.title;
            state.fateSideListData = resultData.data;

            // 重置选中状态
            switch(data.type) {
                case 'dayun':
                    state.fortuneListData = FATE_DATA_MANAGER.resetListDataChoosed(state.fortuneListData);
                    break;
                case 'liunian':
                    state.liunianListData = FATE_DATA_MANAGER.resetListDataChoosed(state.liunianListData);
                    break;
                case 'liuyue':
                    state.liuyueListData = FATE_DATA_MANAGER.resetListDataChoosed(state.liuyueListData);
                    break;
                case 'liuri':
                    state.liuriListData = FATE_DATA_MANAGER.resetListDataChoosed(state.liuriListData);
                    break;
                default:
                    break;
            }
            // 特殊处理:十列的时候要做处理
            if(data.type == 'dayun' && state.showTable == 10) {
                state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, {id: 0})
                state.liunianListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liunianListData, {id: 0})
                AppFate.$store.dispatch('detail/fatefortune/showDetailLiuNian', state.curDaYun);
            }

            if(data.type == 'dayun' && state.showTable == 5) {
                state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, {id: 0})
            }
            // 点击「今」之后，点击删除会出现空白
            if(data.type == 'liunian' && state.liunianListData.length == 0) {
                AppFate.$store.dispatch("detail/fatefortune/showDetailLiuNian", state.fateSideListData[0]);
            }
            if(data.type == 'liuyue' && state.liuyueListData.length == 0) {
                AppFate.$store.dispatch("detail/fatefortune/showDetailLiuYue", state.fateSideListData[1].year);
            }
            if(data.type == 'liuri' && state.showTable == 10 && state.liuyueListData.length == 0) {
                AppFate.$store.dispatch("detail/fatefortune/showDetailLiuYue", state.fateSideListData[1].year);
                AppFate.$store.dispatch("detail/fatefortune/showDetailLiuRi", state.fateSideListData[2].time);
            }
            
            // 处理神煞列表数据
            var newL = resultData.data.length + 4;
            var shenshaList = AppFate.$store.state.detail.detailShenShaList;
            AppFate.$store.state.detail.detailShenShaList.splice(newL, shenshaList.length);

            // 更新合化冲数据状态
            AppFate.$store.state.detail.updateRelation = true;
            console.log("types.DETAIL_FATE_SIDE_DELETE", state.fateSideListData)
        },
        [types.PLUGIN_CHECK_DETAIL_FORTUNE_DATA](state) {
            // 10列布局:未选中流年流月状态
            if(state.showTable == 10 && state.showType == 'dayun') {
                AppFate.$store.dispatch('detail/fatefortune/showDetailLiuNian', state.curDaYun);
            }
            // 5列布局:未选中流年流月状态
            if(state.showTable == 5 && state.fateSideListData.length == 0) {
                state.showType = 'dayun';
            }
            console.log('types.PLUGIN_CHECK_DETAIL_FORTUNE_DATA------', state.showType, state.showTable, state.curDaYun);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIUNIAN](state, data) {
            state.showType = "liunian";
            // 处理传入参数
            var ageStr = data.title[1];
                ageStr = ageStr.slice(0, -1);
            var yearData = {
                startAge: parseInt(ageStr),
                yearNum: data.year,
                dayunBefore: data.before
            };
            state.liunianListData = FATE_DATA_MANAGER.getFortuneLiuNianDataByYear(state.fateInfo, yearData, 'detail');
            console.log("types.DETAIL_SHOW_LIUNIAN", yearData, state.liunianListData);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIUYUE](state, yearNum) {
            state.showType = "liuyue";
            state.liuyueListData = FATE_DATA_MANAGER.getFortuneLiuYueDataByYear(state.fateInfo, yearNum, 'detail');
            // console.log("types.DETAIL_SHOW_LIUYUE", yearNum, state.liuyueListData);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIURI](state, yueTime) {
            state.showType = "liuri";
            state.liuriListData = FATE_DATA_MANAGER.getFortuneLiuRiDataByYear(state.fateInfo, yueTime);
            // console.log("types.DETAIL_SHOW_LIURI", yueTime, state.liuriListData);
        },
        [types.PLUGIN_INIT_DETAIL_SHOW_LIUSHI](state, shiTime) {
            state.showType = "liushi";
            state.liushiListData = FATE_DATA_MANAGER.getFortuneLiuShiDataByYear(state.fateInfo, state.fateSideListData, shiTime);
            // console.log("types.DETAIL_SHOW_LIUSHI", shiTime, state.liushiListData);
        },
        [types.PLUGIN_INIT_RESET_DETAIL_FATE_FORTUNE_DATA](state) {
            // 重置数据
            state.detailData = {};
            state.fateInfo = {};
            state.fateListData = [];
            state.fateSideListData = [];
            state.fortuneTitle = '';
            state.fortuneListData = [];
            state.fortuneSideListData = [];
            state.showLabel = false;
            state.showType = 'dayun';
            state.subTitle = '';
            state.curDaYun = {};
            state.liunianListData = [];
            state.liuyueListData = [];
            state.liuriListData = [];
            state.liushiListData = [];
        },
    },
    actions: {
        initDetailFateFortune({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA, data);
        },
        initDetailTodayFateFortune({ commit, state }) {
            state.fateSideListData = [];
            state.fateSideListData = FATE_DATA_MANAGER.getTodayFateSideListData(state.fateInfo, state.fortuneListData);
            if(state.fateSideListData.length >= 4) {
                commit(types.PLUGIN_INIT_DETAIL_SHOW_LIURI, state.fateSideListData[2].time)
                commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUSHI, state.fateSideListData[3].g)
            }
        },
        addDetailFateSide({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_ADD, data);
        },
        deleteDetailFateSide({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE, data);
        },
        checkDetailFortuneData({ commit }) {
            commit(types.PLUGIN_CHECK_DETAIL_FORTUNE_DATA)
        },
        showDetailLiuNian({ commit }, data) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUNIAN, data);
        },
        showDetailLiuYue({ commit }, yearNum) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUYUE, yearNum);
        },
        showDetailLiuRi({ commit }, yueTime) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIURI, yueTime);
        },
        showDetailLiuShi({ commit }, shiTime) {
            commit(types.PLUGIN_INIT_DETAIL_SHOW_LIUSHI, shiTime);
        },
        resetDetailData({ commit }) {
            commit(types.PLUGIN_INIT_RESET_DETAIL_FATE_FORTUNE_DATA)
        },
        showContrastItemFortune({ state, commit }) {
            let fortuneData = state.fateSideListData[0];
            if(fortuneData) {
                state.showType = "dayun";
                commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE, fortuneData);
            }
        },
        showContrastItemLiuNian({ state, commit }) {
            let liunianData = state.fateSideListData[1];
            if(liunianData) {
                state.showType = "liunian";
                commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE, liunianData);
            }
        },
        showContrastItemLiuYue({ state, commit }, data) {
            let dayunData = state.fortuneListData[data.dayunIndex];
            if(!dayunData) { return; }
            commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_ADD, dayunData);
            var ageStr = dayunData.title[1];
                ageStr = ageStr.slice(0, -1);
            var yearData = {
                startAge: parseInt(ageStr),
                yearNum: dayunData.year,
                dayunBefore: dayunData.before
            };
            state.showType = "liuyue";
            state.liunianListData = FATE_DATA_MANAGER.getFortuneLiuNianDataByYear(state.fateInfo, yearData, 'detail');

            let liunianData = state.liunianListData[data.liunianIndex];
            commit(types.PLUGIN_INIT_DETAIL_FATE_SIDE_ADD, liunianData);
            state.liuyueListData = FATE_DATA_MANAGER.getFortuneLiuYueDataByYear(state.fateInfo, liunianData.year, 'detail');
        }
    }
}